/**
 * 🟥 CUADRO NEGRO V3 — Detector de URL de GitHub.
 *
 * Si el mensaje contiene una URL pública de GitHub válida, devuelve
 * { isGithub:true, url, owner, repo, branch } para que useChatSend.js
 * dispare ProjectGitHubImportPrompt en lugar del flujo normal.
 *
 * Sincronizado con backend (routes/project_builder.py::_parse_github_url).
 */

const GITHUB_URL_RE = /https?:\/\/(?:www\.)?github\.com\/([A-Za-z0-9._-]+)\/([A-Za-z0-9._-]+)(?:(?:\.git)|(?:\/tree\/([^\s?#]+)))?(?=\b|[\s?#]|$)/i;

export function detectGithubUrl(message) {
  if (!message || typeof message !== 'string') return { isGithub: false };
  const match = message.match(GITHUB_URL_RE);
  if (!match) return { isGithub: false };

  let url = match[0];
  // Quitar trailing punctuation común (puntos, comas) que puedan venir.
  url = url.replace(/[).,!?]+$/g, '');

  let owner = match[1];
  let repo = match[2];
  if (repo.endsWith('.git')) repo = repo.slice(0, -4);
  const branch = match[3] || null;

  return { isGithub: true, url, owner, repo, branch };
}

export default detectGithubUrl;
